(function () {
  'use strict';

  function getConfig() {
    return window.__BOOSTER_PRELOAD__ || {};
  }

  function init() {
    var config = getConfig();
    if (!config.boosterUrl) return;

    var boosterLoaded = false;
    var boosterLoading = false;

    function loadBooster() {
      if (boosterLoaded || boosterLoading) return;
      boosterLoading = true;

      var script = document.createElement('script');
      script.src = config.boosterUrl;
      script.defer = true;
      script.onload = function () {
        boosterLoaded = true;
        boosterLoading = false;
        document.dispatchEvent(new CustomEvent('booster:loaded'));
      };
      script.onerror = function () {
        boosterLoading = false;
      };
      document.body.appendChild(script);
    }

    function setupBoosterPreload() {
      var addToCartSelectors = '.js-add-to-cart, [data-atc], .button--addToCart, .add-to-cart-btn, [data-add-to-cart], .add-to-cart-button';
      var addToCartButtons = document.querySelectorAll(addToCartSelectors);

      addToCartButtons.forEach(function (button) {
        button.addEventListener('mouseenter', loadBooster, { once: true, passive: true });
        button.addEventListener('touchstart', loadBooster, { once: true, passive: true });
        button.addEventListener('focus', loadBooster, { once: true, passive: true });
        button.addEventListener('click', loadBooster, { once: true, passive: true, capture: true });
      });

      document.querySelectorAll('input[data-search], input[name="q"][type="search"]').forEach(function (input) {
        input.addEventListener('focus', loadBooster, { once: true, passive: true });
        input.addEventListener('input', loadBooster, { once: true, passive: true });
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        var target = e.target.closest('[data-cart-toggle], .cart-icon, .js-cart-toggle, [href*="cart"]');
        if (target) {
          loadBooster();
        }

        var searchTarget = e.target.closest('.search__icon, [aria-label="Search"]');
        if (searchTarget) {
          if (boosterLoaded) return;
          loadBooster();
          // replay the open action once booster is ready
          document.addEventListener('booster:loaded', function () {
            setTimeout(function () {
              if (window.BoosterTheme && window.BoosterTheme.ELEMENTS) {
                window.BoosterTheme.ELEMENTS.openSearch(searchTarget);
              }
            }, 0);
          }, { once: true });
        }
      },
      true
    );

    document.addEventListener('cart:open', loadBooster);
    document.addEventListener('cart:item:added', loadBooster);
    document.addEventListener('booster:cart:update', loadBooster);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupBoosterPreload);
    } else {
      setupBoosterPreload();
    }

    var isMobile = window.innerWidth <= 768;
    var fallbackDelayMs = isMobile ? (config.mobileDelayMs || 1500) : (config.desktopDelayMs || 2000);
    setTimeout(function () {
      if (!boosterLoaded && !boosterLoading) {
        loadBooster();
      }
    }, fallbackDelayMs);
  }

  init();
})();
